import React, { useEffect, useRef } from "react";
import Slider from "react-slick";

export default function AboutSlider({ images = [] }) {
  const sliderRef = useRef(null);
  const sliderImages = images.length < 8 ? [...images, ...images] : images;

  useEffect(() => {
    if (!images.length) {
      return undefined;
    }

    const slider = sliderRef.current;
    const startTimer = window.setTimeout(() => {
      if (slider?.innerSlider) {
        slider.slickPlay();
      }
    }, 1000);

    return () => {
      window.clearTimeout(startTimer);
    };
  }, [images.length]);

  const settings = {
    arrows: false,
    autoplay: false,
    autoplaySpeed: 0,
    cssEase: "linear",
    infinite: true,
    pauseOnFocus: false,
    pauseOnHover: false,
    slidesToScroll: 1,
    speed: 6000,
    variableWidth: true,
    waitForAnimate: true,
  };

  if (!images.length) {
    return null;
  }

  return (
    <section className="about-slider" aria-label="Catalyze moments">
      <Slider ref={sliderRef} {...settings}>
        {sliderImages.map((image, index) => (
          <div
            className={`about-slider-item about-slider-item--${
              image.size || "large"
            }`}
            key={`${image.src}-${index}`}
          >
            <img src={image.src} alt={image.alt} />
          </div>
        ))}
      </Slider>
    </section>
  );
}
